import React, { useEffect } from 'react';
import { Phone, Mail, MapPin, Clock, Send, MessageSquare } from 'lucide-react';
import { CONTACT_INFO } from '../mock/mock';
import { useToast } from '../hooks/use-toast';

const Contact = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  const { toast } = useToast();

  const submit = (e) => {
    e.preventDefault();
    toast({ title: 'Message sent (demo)', description: 'Thanks for reaching out — our team will reply soon.' });
    e.target.reset();
  };

  const cards = [
    { icon: Phone, label: 'Call Us', value: CONTACT_INFO.phone, href: `tel:${CONTACT_INFO.phone.replace(/\s/g, '')}` },
    { icon: Mail, label: 'Email Us', value: CONTACT_INFO.email, href: `mailto:${CONTACT_INFO.email}` },
    { icon: MapPin, label: 'Coverage Area', value: CONTACT_INFO.address },
    { icon: Clock, label: 'Hours', value: CONTACT_INFO.hours },
  ];

  return (
    <div>
      <div className="relative bg-[#141414] text-white py-20 overflow-hidden">
        <img src="https://images.unsplash.com/photo-1722974180453-305758503804?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600" alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#141414] to-[#141414]/60" />
        <div className="container-fes relative">
          <span className="section-label">Contact</span>
          <h1 className="font-head text-4xl md:text-5xl uppercase mt-2">Get In Touch</h1>
          <p className="text-gray-300 mt-4 max-w-none text-lg whitespace-normal lg:whitespace-nowrap">Request an event quote, ask about our equipments, or book training. We are here to help.</p>
        </div>
      </div>

      <section className="py-16 md:py-20 bg-white">
        <div className="container-fes grid grid-cols-1 lg:grid-cols-[1fr_1.2fr] gap-12">
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-8">
              {cards.map((c) => (
                <div key={c.label} className="bg-[#f4f6fa] rounded-lg p-6 hover-lift">
                  <div className="w-11 h-11 rounded-lg bg-white flex items-center justify-center text-[#c8102e] mb-3"><c.icon size={20} /></div>
                  <h4 className="font-cond uppercase tracking-wide text-gray-500 text-xs mb-1">{c.label}</h4>
                  {c.href ? (
                    <a href={c.href} className="font-semibold text-[#141414] hover:text-[#c8102e] transition-colors whitespace-nowrap">{c.value}</a>
                  ) : (
                    <p className="font-semibold text-[#141414]">{c.value}</p>
                  )}
                </div>
              ))}
            </div>
            <div className="rounded-lg overflow-hidden h-64 border border-gray-100">
              <iframe
                title="map"
                src="https://www.openstreetmap.org/export/embed.html?bbox=150.5%2C-34.2%2C151.5%2C-33.5&layer=mapnik"
                className="w-full h-full border-0"
                loading="lazy"
              />
            </div>
          </div>

          <div className="bg-white rounded-lg border border-gray-100 p-8">
            <div className="flex items-center gap-3 mb-6">
              <MessageSquare size={26} className="text-[#c8102e]" />
              <h2 className="font-head text-2xl uppercase text-[#141414]">Send Us A Message</h2>
            </div>
            <form onSubmit={submit} className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input required placeholder="First name" className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-[#c8102e] transition-colors" />
                <input required placeholder="Last name" className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-[#c8102e] transition-colors" />
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <input required type="email" placeholder="Email" className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-[#c8102e] transition-colors" />
                <input placeholder="Phone" className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-[#c8102e] transition-colors" />
              </div>
              <select className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-[#c8102e] transition-colors text-gray-600 font-cond">
                <option>General Enquiry</option>
                <option>Event Medical Quote</option>
                <option>Product / Order Support</option>
                <option>Training Booking</option>
              </select>
              <textarea required rows="5" placeholder="How can we help?" className="w-full px-4 py-3 border border-gray-200 rounded-lg focus:outline-none focus:border-[#c8102e] transition-colors resize-none" />
              <button className="btn-crimson w-full text-base">Send Message <Send size={16} /></button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
